import { useEffect, useState } from "react";
import {
  activeUserIcon,
  DollarSign,
  ImageUpload,
  photoDistributedIcon,
  Rekognition,
  S3Logo,
  SystemUpload,
  totalEventIcon,
  totalPhotoIcon,
} from "../../../assets/images";
import { GetDashboardData } from "../../../apis/events";
import { Skeleton } from "antd";
import { useSelector } from "react-redux";

export default function DashBoardPage() {
  const { user } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);
  const [dashboardStat, setDashboardStat] = useState({
    totalEvent: 0,
    totalUser: 0,
    totalPhoto: 0,
    totalDistributedPhoto: 0,
    totalFace: 0,
  });

  useEffect(() => {
    setLoading(true);
    GetDashboardData()
      .then((res) => {
        if (res.status === 200) {
          const respData = res.data.data;
          setDashboardStat({
            totalEvents: respData.total_events ?? 0,
            totalEvent: respData.total_active_event,
            totalUser: respData.total_users,
            totalPhoto: respData.total_photos,
            totalDistributedPhoto: respData.total_photo_distributed,
            webTotalDistributedPhoto: respData.web_total_photo_distributed ?? 0,
            totalFace: respData.total_unique_face,
            total_aws_api_calls: respData.total_aws_api_calls,
            total_aws_api_calls_cost: respData.total_aws_api_calls_cost,
            total_system_uploaded_photos: respData.total_system_uploaded_photos,
            total_user_contributed_photos:
              respData.total_user_contributed_photos,
            s3_space_cost: respData.s3_space_cost,
            s3_space_in_gb: respData.s3_space_in_gb,
            cloudfront_bandwidth_cost: respData.cloudfront_bandwidth_cost,
            total_lambda_cost: respData.total_lambda_cost,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="page-title m-0">Dashboard</h3>
      </div>
      {loading ? (
        <Skeleton />
      ) : (
        <div className="d-flex flex-wrap mt-3 gap-3">
          <div className="card custom-card dashboard-card">
            <div className="d-flex gap-3">
              <div className="stat-left">
                <img src={totalEventIcon} alt="" />
              </div>
              <div className="stat-right">
                <h3>{dashboardStat.totalEvents}</h3>
                <p>Total Events</p>
              </div>
            </div>
          </div>
          <div className="card custom-card dashboard-card">
            <div className="d-flex gap-3">
              <div className="stat-left">
                <img src={totalEventIcon} alt="" />
              </div>
              <div className="stat-right">
                <h3>{dashboardStat.totalEvent}</h3>
                <p>Total Active Events</p>
              </div>
            </div>
          </div>
          <div className="card custom-card dashboard-card">
            <div className="d-flex gap-3">
              <div className="stat-left">
                <img src={activeUserIcon} alt="" />
              </div>
              <div className="stat-right">
                <h3>{dashboardStat.totalUser}</h3>
                <p>Total Active Users</p>
              </div>
            </div>
          </div>
          <div className="card custom-card dashboard-card">
            <div className="d-flex gap-3">
              <div className="stat-left">
                <img src={photoDistributedIcon} alt="" />
                <span className="badge bg-dark mt-1 d-block">WhatsApp</span>
              </div>
              <div className="stat-right">
                <h3>{dashboardStat.totalDistributedPhoto}</h3>
                <p>Photos Distributed Till Now</p>
              </div>
            </div>
          </div>
          <div className="card custom-card dashboard-card">
            <div className="d-flex gap-3">
              <div className="stat-left">
                <img src={photoDistributedIcon} alt="" />
                <span className="badge bg-dark mt-1 d-block">Web</span>
              </div>
              <div className="stat-right">
                <h3>{dashboardStat.webTotalDistributedPhoto}</h3>
                <p>Photos Distributed Till Now</p>
              </div>
            </div>
          </div>
          <div className="card custom-card dashboard-card">
            <div className="d-flex gap-3">
              <div className="stat-left">
                <img src={totalPhotoIcon} alt="" />
              </div>
              <div className="stat-right">
                <h3>{dashboardStat.totalPhoto}</h3>
                <p>Total Number of Photos</p>
              </div>
            </div>
          </div>
          <div className="card custom-card dashboard-card">
            <div className="d-flex gap-3">
              <div className="stat-left">
                <img src={SystemUpload} alt="" />
              </div>
              <div className="stat-right">
                <h3>{dashboardStat.total_system_uploaded_photos}</h3>
                <p>Total System Uploaded Photos</p>
              </div>
            </div>
          </div>
          <div className="card custom-card dashboard-card">
            <div className="d-flex gap-3">
              <div className="stat-left">
                <img src={ImageUpload} alt="" />
              </div>
              <div className="stat-right">
                <h3>{dashboardStat.total_user_contributed_photos}</h3>
                <p>Total User Contributed Photos</p>
              </div>
            </div>
          </div>
          {/* <div className="card custom-card dashboard-card">
            <div className="d-flex gap-3">
              <div className="stat-left">
                <img src={faceIcon} alt="" />
              </div>
              <div className="stat-right">
                <h3>{dashboardStat.totalFace}</h3>
                <p>Unique Faces Found in Photos</p>
              </div>
            </div>
          </div> */}
          {user?.user_type === "admin" && (
            <>
              <div className="card custom-card dashboard-card">
                <div className="d-flex gap-3">
                  <div className="stat-left">
                    <img src={Rekognition} alt="" />
                  </div>
                  <div className="stat-right">
                    <h3>{dashboardStat.total_aws_api_calls}</h3>
                    <p>Total Rekognition API Calls</p>
                  </div>
                </div>
              </div>
              <div className="card custom-card dashboard-card">
                <div className="d-flex gap-3">
                  <div className="stat-left">
                    <img
                      src={DollarSign}
                      alt=""
                      style={{ width: "40px", height: "40px" }}
                    />
                  </div>
                  <div className="stat-right">
                    <h3>{dashboardStat.total_aws_api_calls_cost}</h3>
                    <p>Total Rekognition Cost</p>
                  </div>
                </div>
              </div>
              <div className="card custom-card dashboard-card">
                <div className="d-flex gap-3">
                  <div className="stat-left">
                    <img
                      src={DollarSign}
                      alt=""
                      style={{ width: "40px", height: "40px" }}
                    />
                  </div>
                  <div className="stat-right">
                    <h3>{dashboardStat.s3_space_cost}</h3>
                    <p>AWS S3 Storage Cost</p>
                  </div>
                </div>
              </div>
              <div className="card custom-card dashboard-card">
                <div className="d-flex gap-3">
                  <div className="stat-left">
                    <img src={S3Logo} alt="" />
                  </div>
                  <div className="stat-right">
                    <h3>{dashboardStat.s3_space_in_gb}</h3>
                    <p>AWS S3 Storage</p>
                  </div>
                </div>
              </div>
              <div className="card custom-card dashboard-card">
                <div className="d-flex gap-3">
                  <div className="stat-left">
                    <img
                      src={DollarSign}
                      alt=""
                      style={{ width: "40px", height: "40px" }}
                    />
                  </div>
                  <div className="stat-right">
                    <h3>{dashboardStat.cloudfront_bandwidth_cost}</h3>
                    <p>CloudFront Bandwidth Cost</p>
                  </div>
                </div>
              </div>
              <div className="card custom-card dashboard-card">
                <div className="d-flex gap-3">
                  <div className="stat-left">
                    <img
                      src={DollarSign}
                      alt=""
                      style={{ width: "40px", height: "40px" }}
                    />
                  </div>
                  <div className="stat-right">
                    <h3>{dashboardStat.total_lambda_cost}</h3>
                    <p>Total Lambda Cost</p>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}
